export default "__VITE_ASSET__CI8wSR2Z__"